import { createAction } from 'redux-actions'

import * as constants from './constants'

export const fetchAssistantAgentSettings = createAction(
  constants.FETCH_ASSISTANT_AGENT_SETTINGS
)
export const fetchAssistantAgentSettingsPending = createAction(
  constants.FETCH_ASSISTANT_AGENT_SETTINGS_SUCCESS
)
export const fetchAssistantAgentSettingsFailed = createAction(
  constants.FETCH_ASSISTANT_AGENT_SETTINGS_FAILED
)
export const fetchAssistantAgentSettingsSuccess = createAction(
  constants.FETCH_ASSISTANT_AGENT_SETTINGS_PENDING
)

export const patchAssistantAgentSettings = createAction(
  constants.PATCH_ASSISTANT_AGENT_SETTINGS
)
export const patchAssistantAgentSettingsPending = createAction(
  constants.PATCH_ASSISTANT_AGENT_SETTINGS_SUCCESS
)
export const patchAssistantAgentSettingsFailed = createAction(
  constants.PATCH_ASSISTANT_AGENT_SETTINGS_FAILED
)
export const patchAssistantAgentSettingsSuccess = createAction(
  constants.PATCH_ASSISTANT_AGENT_SETTINGS_PENDING
)
